import { render } from "./CardiovascularSummary.vue?vue&type=template&id=3d6fee6d"
import script from "./CardiovascularSummary.vue?vue&type=script&lang=js"
export * from "./CardiovascularSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__